import { render, staticRenderFns } from "./Nurse.vue?vue&type=template&id=310ea64a&scoped=true&"
import script from "./Nurse.vue?vue&type=script&lang=js&"
export * from "./Nurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ea64a",
  null
  
)

export default component.exports